import { ArrowRight } from "lucide-react";

export function Hero({ content }) {
  const { heroPanels, hero } = content;

  return (
    <section id="top" className="hero-section" data-testid="hero-section">
      <div className="hero-panels" aria-hidden="true" data-testid="hero-visual-panels">
        {heroPanels.map((panel, index) => (
          <div
            key={panel.title}
            className="hero-panel"
            data-testid={`hero-panel-${index + 1}`}
            style={{ backgroundImage: `url(${panel.image})` }}
          >
            <div className="hero-panel-label" data-testid={`hero-panel-label-${index + 1}`}>
              <span>{panel.label}</span>
              <strong>{panel.title}</strong>
            </div>
          </div>
        ))}
      </div>

      <div className="hero-overlay" />
      <div className="hero-content">
        <p className="overline" data-testid="hero-overline">{hero.overline}</p>
        <h1 data-testid="hero-headline">{hero.headline}</h1>
        <p className="hero-company" data-testid="hero-company-name">{hero.company}</p>
        <p className="hero-subheadline" data-testid="hero-subheadline">
          {hero.subheadline}
        </p>
        <p className="hero-description" data-testid="hero-description">
          {hero.description}
        </p>

        <div className="hero-domains" data-testid="hero-business-domains">
          {heroPanels.map((panel) => (
            <span key={panel.title} data-testid={`hero-domain-${panel.title.toLowerCase().replaceAll(" ", "-").replaceAll("&", "and")}`}>
              {panel.title}
            </span>
          ))}
        </div>

        <div className="hero-actions" data-testid="hero-cta-group">
          <a className="btn btn-primary" href="#solutions" data-testid="hero-explore-solutions-button">
            {hero.ctas[0]} <ArrowRight size={16} aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}